module.exports = __webpack_public_path__ + "static/media/icon_info02.f6146b20.svg";